import service from "../service";

export interface DeviceReadingAgentListParams {
  page?: number;
  key?: string;
  intPageSize?: number;
}

export interface DeviceReadingAgentItem {
  Id?: string | number;
  名称?: string;
  提示词?: string;
  ISDELETED?: boolean;
  [key: string]: any;
}

export default {
  list(params: DeviceReadingAgentListParams = {}, data: any[] = []): Promise<any> {
    return service({
      method: "POST",
      url: "/设备读数智能体/列表查询",
      params: {
        page: params.page || 1,
        key: params.key || "",
        intPageSize: params.intPageSize || 50,
      },
      data,
    });
  },

  detail(id: string | number): Promise<any> {
    return service({
      method: "GET",
      url: "/设备读数智能体/ID查询",
      params: { id },
    });
  },

  save(data: DeviceReadingAgentItem): Promise<any> {
    return service({
      method: "POST",
      url: "/设备读数智能体/新增或更新设备读数智能体",
      data,
    });
  },

  delete(id: string | number): Promise<any> {
    return service({
      method: "DELETE",
      url: "/设备读数智能体/ID删除",
      params: { id },
    });
  },
};
